<template>
  <section v-if="includeExcludeData">
    <h1>Inclusions & Exclusions</h1>
    <table class="table has-smallest-tiny-font include-exclude" style="z-index: 100000">
      <thead>
        <tr>
          <th><div class="orange-dot">Item No.</div></th>
          <th><div class="orange-dot">Tasks</div></th>
          <th><div class="orange-dot">{{ productBrand }}</div></th>
          <th><div class="orange-dot">Client</div></th>
        </tr>
      </thead>
      <tbody>
        <tr 
          v-for="row in includeExcludeData" 
          :key="row['item no.']"
          :class="getRowClass(row)"
        >
          <td v-for="(value, label) in row" :key="label">
            {{ value === true ? 'X' : value === false ? '' : value }}
          </td>
        </tr>
      </tbody>
    </table>

    <div class="content-subsection">
      <h3>PROPOSAL VALIDITY</h3>
      <div class="mt-2">This proposal is valid for thirty (30) days.</div>
    </div>
  </section>
</template>

<script>
import { inclusionsAndExclusions } from '@/data/inclusions-and-exclusions'

export default {
  props: {
    rfq: {
      type: Object
    },
    productBrand: {
      type: String
    },
    proposalInfo: {
      type: Array
    }
  },
  data() {
    return {
      inclusionsAndExclusions: inclusionsAndExclusions
    }
  },
  computed: {
    quoteType({ proposalInfo }) {
      return proposalInfo.find(s => s.id === 'quote_type')
    },
    includeExcludeData({ quoteType, inclusionsAndExclusions }) {
      return quoteType && quoteType.value
        ? inclusionsAndExclusions[quoteType.value] 
        : null
    }
  },
  methods: {
    getRowClass(row) {
      const itemNo = row['item no.']
      const company = Object.keys(row).includes('mitrex') ? row['mitrex'] : row['cladify']
      const client = row['client']
      const blank = company === '' && client === ''
      const itemNoLen = itemNo ? itemNo.toString().split('.').length : 0
      if (itemNoLen === 1 && blank) {
        return 'section'
      } else if (itemNoLen === 2 && blank) {
        return 'subsection'
      } else {
        return 'detail'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../styles/table.scss';

.include-exclude {
  width: 100%;
  font-weight: lighter;
  tr td, tr th {
    page-break-inside: avoid;
    page-break-after: auto;
  }
  thead {
    text-transform: none !important;
    font-size: 1.02em;
    border-bottom: 3px solid white;
    th {
      border-top: 0.5px solid #D5D3CE;
      border-bottom: none;
      &:not(:last-child) {
        border-right: 0.5px solid #D5D3CE;
      }
      padding-bottom: 2px;
    }
  }
  td, th {
    text-transform: capitalize !important;
    &:first-child {
      min-width: 80px;
      font-weight: normal;
    }
    &:nth-child(3), &:nth-child(4) {
      min-width: 65px;
      text-align: center;
      vertical-align: middle;
    }
  }
  th {
    text-align: center;
    color: #181A19;
  }
  tbody tr {
    &.section {
      background: #B4B4AE;
      color: #181A19;
      font-size: 1.05rem;
      font-weight: normal;
      td {
        padding: 0.3em 0.75em;
      }
    }
    &.subsection {
      background: #EAE8E1;
      color: #181A19;
      td {
        padding-top: 3px;
        padding-bottom: 3px; 
      }
    }
    &.detail {
      color: #181A19;
      padding-top: 3px;
      padding-bottom: 3px; 
      td {
        padding-top: 3px;
        padding-bottom: 3px; 
        border-bottom: 0.5px solid #D5D3CE;
      }
    }
  }
}

.content-subsection {
  margin-top: 3em !important;
}
</style>